import xeroxApi from '../axios/xeroxApi';
class AuthService {
    async generateToken(req) {
        return Promise.resolve(xeroxApi.post(`auth/generateToken/`, req));
    }
}

export default AuthService;